import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetListSingleReport  {
    _originalTypeClassName = "zERP.BO.AssetListSingleReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetListSingleReport.translate = translateService;
}
this.PreviousAcquisitionValue = null;
this.PreviousAdjustmentValue = null;
this.PreviousDepreciationValue = null;
this.CurrentAcquisitionValue = null;
this.CurrentAdjustmentValue = null;
this.CurrentDepreciationValue = null;
this.NonDepreciatedValue = null;
this.GroupBy = null;
this.AssetListSingleReportKey = null;
this._key = this.AssetListSingleReportKey = 0; 
}

static translate: TranslateService;
_key: any;
PreviousAcquisitionValue:any;
PreviousAdjustmentValue:any;
PreviousDepreciationValue:any;
CurrentAcquisitionValue:any;
CurrentAdjustmentValue:any;
CurrentDepreciationValue:any;
NonDepreciatedValue:any;
GroupBy:any;
Asset:any;
private _AssetListSingleReportKey:any;
get AssetListSingleReportKey(): any {
    return this._AssetListSingleReportKey;
  }
set AssetListSingleReportKey(value: any) {
    this._AssetListSingleReportKey = value;
    this._key = value;
  }
static setAsset = ($this, value) => {
var oldValue = $this.Asset;
$this.Asset = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AssetListSingleReportKey == null || $this.AssetListSingleReportKey == 0;
            }


}